import E_GS from './GS';
import E_Other from './Other';
import { useGlobal } from '@/utils/useGlobal';

export default function E({ callBuy, updateSolar }: any) {
    const { useRouter } = useGlobal();
    const { locale } = useRouter();
    const IS_NA = ['us', 'ca'].includes(locale);
    const IS_EU = ['eu', 'uk', 'de', 'fr', 'it', 'es', 'nl'].includes(locale);
    const IS_ROW = ['kr', 'au', 'za'].includes(locale);
    const IS_GS: boolean = IS_NA || IS_EU || IS_ROW;

    return <>{IS_GS ? <E_GS callBuy={callBuy} updateSolar={updateSolar} /> : <E_Other callBuy={callBuy} />}</>;
}
